import { render, staticRenderFns } from "./pPicker.vue?vue&type=template&id=5f55da6a&scoped=true"
import script from "./pPicker.vue?vue&type=script&lang=js"
export * from "./pPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55da6a",
  null
  
)

export default component.exports